import Form from 'src/utils/Form.js'

class RebitAccount extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get(`rebit-accounts/${this.id}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`rebit-accounts?${parameters}`).then(then)
  }

  static list(then) {
    return new Form().get(`rebit-accounts/list`).then(then)
  }

  static balances(parameters, then) {
    return new Form().get(`rebit-accounts/balances?${parameters}`).then(then)
  }

  syncRealBalance(then) {
    return super.get(`rebit-accounts/${this.currency_acronym}/sync-balance`).then(then)
  }

  create(then) {
    this.corporations = undefined
    this.currency_acronym = typeof this.currency_acronym === 'object' && this.currency_acronym !== null ? this.currency_acronym.acronym : this.currency_acronym
    return super.post(`rebit-accounts`).then(then)
  }

  update(then) {
    this.corporations = undefined
    this.currency_acronym = typeof this.currency_acronym === 'object' && this.currency_acronym !== null ? this.currency_acronym.acronym : this.currency_acronym
    return super.patch(`rebit-accounts/${this.id}`).then(then)
  }

  destroy(then) {
    return super.delete(`rebit-accounts/${this.id}`).then(then)
  }
}

export default RebitAccount
